export const LOGIN_REQUEST = `
  mutation LoginMutation($password: String!, $username: String!) {
    login(password: $password, username: $username) {
      error
      token
      username
      userId
      email
      groups
      expiryAt
    }
  }
`
export const CONFIRM_SIGNUP_REQUEST = `
  mutation confirmUserSignUp($refCode: String!, $code: String!) {
    confirmUserSignUp(refCode: $refCode, code: $code) {
      error
      email
    }
  }
`

export const LOGOUT_REQUEST = `
  mutation LogoutMutation {
    logout {
      error
    }
  }
`
export const WHOAMI_REQUEST = `
  {
    "query": "query WhoAmI { whoAmI { token username userId email groups expiryAt error }}"
  }`


